import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Boat } from '@shared/models/boat';
import { Company } from '@shared/models/company';
import { Person } from '@shared/models/person';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'form-widget-boat-by-person-or-company',
    templateUrl: './form-widget-boat-by-person-or-company.component.html',
    standalone: false
})
export class FormWidgetBoatByPersonOrCompanyComponent implements AfterViewInit, OnDestroy {

    @Input() parentFormGroup: UntypedFormGroup;

    @Input() appearance: MatFormFieldAppearance = 'outline';

    @Input() hideDivider = false;

    @Input() boat: Boat;

    typeControl: UntypedFormControl = new UntypedFormControl('all');

    boatOwnerName: string = null;

    // Feed form-widget-boat's owner query so its top list comes from /boats/options?personId=,
    // which carries the owner relation that the slim person.boats payload omits.
    person$ = new BehaviorSubject<Person>(null);

    company$ = new BehaviorSubject<Company>(null);

    constructor() {

        this.typeControl.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(type => {
                this.parentFormGroup.get('companyForm')?.reset();
                this.parentFormGroup.get('personForm')?.reset();
                this._resetOwner();
            });

    }

    ngAfterViewInit(): void {
        this.parentFormGroup.setControl('type', this.typeControl);

        this.parentFormGroup.valueChanges
            .pipe(
                untilDestroyed(this),
                map(value => {
                    return {
                        personForm: value.personForm,
                        companyForm: value.companyForm
                    };
                })
            ).subscribe(value => {
            const personForm = value.personForm;
            const companyForm = value.companyForm;
            if (personForm?.person?.id) {
                this.boatOwnerName = personForm.person.fullName;
                this.person$.next(personForm.person);
                this.company$.next(null);
            } else if (companyForm?.company?.id) {
                this.boatOwnerName = companyForm.company.fullName;
                this.company$.next(companyForm.company);
                this.person$.next(null);
            } else {
                // Deselecting the person/company has to drop the top list too, otherwise the
                // 'Boote von …' group keeps showing the previous owner's boats.
                this._resetOwner();
            }
        });

    }

    ngOnDestroy(): void {
        this.parentFormGroup.removeControl('type');
    }

    private _resetOwner(): void {
        this.boatOwnerName = null;
        this.person$.next(null);
        this.company$.next(null);
    }

}
